export default {
  title: 'Bestand toevoegen: {{slot}}',
  replace_title: 'Bestand vervangen: {{slot}}',
  replace_description: 'Het nieuwe bestand vervangt dit bestand. We bewaren het oude in onze administratie.',
  form: {
    kind: {
      label: 'Type ID',
      options: {
        passport: 'Paspoort',
        driver_license: 'Rijbewijs',
        id_card: 'Identiteitskaart',
        residence_permit: 'Verblijfsvergunning',
      },
    },
    front: {
      label: 'Voorzijde',
    },
    back: {
      label: 'Achterzijde',
    },
    file: {
      label: 'Bestand',
    },
    expires_at: {
      label: 'Geldig tot',
      placeholder: 'Selecteer een datum',
    },
    holder: {
      label: 'Van wie is dit ID?',
      options: {
        owner: 'Van mij, de eigenaar',
        partner: 'Van een partner',
      },
    },
    holder_name: {
      label: 'Naam van partner',
      placeholder: 'Voor- en achternaam',
    },
  },
  accepted_files: 'PDF, JPG of PNG, tot {{max}} MB.',
  accepted_images_min: 'Een foto moet minimaal {{min}} KB zijn.',
  errors: {
    file_type: 'Alleen PDF-, JPG- of PNG-bestanden worden geaccepteerd.',
    file_too_large: 'Het bestand is groter dan {{max}} MB.',
    file_too_small: 'Een foto moet minimaal {{min}} KB zijn.',
  },
  buttons: {
    select_file: 'Bestand selecteren',
    submit: 'Uploaden',
    cancel: 'Annuleren',
  },
  toasts: {
    success: 'Bestand geüpload',
    error: 'Het bestand kon niet worden geüpload.',
  },
};
